import { z } from 'zod';
import type { BaseEntity } from './common';
import type { JobOrder } from './jobOrder';
import type { CustomerIntegration } from './customerIntegration';

/**
 * Customer - Cliente
 * Corrisponde al modello backend Customer
 */
export interface Customer extends BaseEntity {
	/** Codice cliente (max 50 caratteri) */
	code: string;
	/** Nome del cliente */
	name: string;
	/** Email del cliente (opzionale) */
	email?: string | null;
	/** Note sul cliente (opzionale) */
	notes?: string | null;
	/** VT ID (max 100 caratteri, opzionale) */
	vtId?: string | null;
	/** Indica se è un cliente interno */
	isInternalCustomer?: boolean | null;
	/** Lista degli ordini del cliente (navigation property) */
	orders?: JobOrder[];
	/** Lista delle integrazioni del cliente (navigation property) */
	integrations?: CustomerIntegration[];
}

/**
 * Tipo per il risultato dell'autocomplete Customers
 * Corrisponde ai campi selezionati nella query OData: id, code, name
 */
export type CustomerAutocompleteResult = Pick<Customer, 'id' | 'code' | 'name'>;

/**
 * Schema Zod per la validazione runtime dei Customer
 */
export const CustomerSchema = z.object({
	// BaseEntity fields
	id: z.number(),
	createdAt: z.string().optional(), // Può non essere sempre presente
	modifiedAt: z.string().optional(),
	createdBy: z.string().optional(), // Può non essere sempre presente
	modifiedBy: z.string().optional(),

	// Customer specific fields
	code: z.string(),
	name: z.string(),
	email: z.string().nullish(), // Può essere string, null o undefined
	notes: z.string().nullish(), // Può essere string, null o undefined
	vtId: z.string().nullish(), // Può essere string, null o undefined
	isInternalCustomer: z.boolean().nullish(), // Può essere boolean, null o undefined

	// Navigation properties opzionali (non validate in runtime)
	orders: z.array(z.any()).optional(),
	integrations: z.array(z.any()).optional(),
});
